import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";


export interface Filter {
  id: number;
  name: string;
  isOpen: boolean;
  value?: string | null;
}

export interface weddingHallState {
  listLayout: 'grid' | 'list';
  layoutTooltop:boolean;
  filters: Filter[],
  data: {
    partnerId: number;
    hopeWeddingStartDate: string;
    hopeWeddingEndDate: string;
    hopeWeddingDaysOfTheWeek: string[];
    hopeWeddingTimes: string[];
    expectedMinPersonnel: number;
    expectedMaxPersonnel: number;
    minVenuePrice: number;
    maxVenuePrice: number;
    minFoodPrice: number;
    maxFoodPrice: number;
    venueTpye: string;
    foodType: string;
    entranceTpye: string;
    parking: string;
    traffic: string;
    virginRoad: string;
    ect: string;
  },
}

const filterList = [
  { id: 1, name: '예식일', isOpen: false }, { id: 2, name: '요일', isOpen: false },
  { id: 3, name: '시간', isOpen: false }, { id: 4, name: '예상하객수', isOpen: false }, { id: 5, name: '대관료', isOpen: false },
  { id: 6, name: '식대', isOpen: false }, { id: 7, name: '웨딩홀타입', isOpen: false }, { id: 8, name: '식사형태', isOpen: false },
  { id: 9, name: '입장방법', isOpen: false }, { id: 10, name: '주차', isOpen: false }, { id: 11, name: '교통', isOpen: false },
  { id: 12, name: '버진로드', isOpen: false }, { id: 13, name: '기타', isOpen: false }
]

const initialState = {
  listLayout: 'grid',
  layoutTooltop: true,
  filters: filterList,
  data: {
    partnerId: 0,
    hopeWeddingStartDate: '',//'2024년9월12일',
    hopeWeddingEndDate: '',//'2024년11월12일',
    hopeWeddingDaysOfTheWeek: [],//['토요일','일요일'],
    hopeWeddingTimes: [],//['11:00','12:00'],
    expectedMinPersonnel: 0,
    expectedMaxPersonnel: 301,
    minVenuePrice: 0,
    maxVenuePrice: 100000001,
    minFoodPrice: 0,
    maxFoodPrice: 200000,
    venueTpye: '',
    foodType: '',
    entranceTpye: '',
    parking: '',
    traffic: '',
    virginRoad: '',
    ect: '',
  },
} as weddingHallState;


const weddingHallSlice = createSlice({
  name: "weddinghall",
  initialState,
  reducers: {
    setListLayout(state, action: PayloadAction<'grid' | 'list'>) {
      state.listLayout = action.payload;
    },
    setLayoutTooltop(state, action: PayloadAction<boolean>) {
      state.layoutTooltop = action.payload;
    }

    // setVenueInfo(state, action: PayloadAction<{ data: Hall }>){
    //     const { data } = action.payload;
    //     state.hall = data;
    //     state.data.paymentAmount = data.deposit;
    //     state.data.partnerId = data.partnerId;
    // },

  },
});

export const {
  // setVenueInfo,
  setListLayout, setLayoutTooltop
} = weddingHallSlice.actions;
// export const weddingHall = (state: RootState) => state.weddingHall;
export default weddingHallSlice.reducer;
